/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import getHCConfigPropertyKey from './getHCConfigPropertyKey';

const getColorStops = (formattingOptions :any) => {

    const defaultStopColorValue = '#33a4ff';
    const defaultStopValues = [0.2, 0.5, 0.7, 1];

    let colorStops = [
        [defaultStopValues[0], defaultStopColorValue],
        [defaultStopValues[1], defaultStopColorValue],
        [defaultStopValues[2], defaultStopColorValue],
        [defaultStopValues[3], defaultStopColorValue]
    ];

    if (Array.isArray(formattingOptions.gaugeStopColors) && formattingOptions.gaugeStopColors.length > 0) {
        const { gaugeStopColors } = formattingOptions;
        let stopValue = formattingOptions.color1Stop || 0;
        let colorValue = gaugeStopColors[0];
        colorStops = [[stopValue, colorValue]];

        for (let i = 1; i < gaugeStopColors.length; i += 1) {
            let defaultStopValueInErrorCase = (1 / (gaugeStopColors.length - 1)) * i;
            defaultStopValueInErrorCase = Math.round(defaultStopValueInErrorCase * (10 ** 2)) / (10 ** 2);
            stopValue = formattingOptions[`color${i + 1}Stop`] || defaultStopValues[i] || defaultStopValueInErrorCase;
            colorValue = gaugeStopColors[i] || defaultStopColorValue;
            colorStops.push([stopValue, colorValue]);
        }
    }

    const valueFromProperties = getHCConfigPropertyKey(formattingOptions, 'yAxis.stops');
    if (valueFromProperties) {
        colorStops = valueFromProperties;
    }

    return colorStops;
};

export default getColorStops;
